export default __webpack_public_path__ + "static/media/trybeer2.2900f4ce.jpeg";